import React from 'react';
import { Typography, Grid, Button, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import Micro from '../../../../../assets/img/micro.jpg'

export default function Description() {
  return (
    <>
     <Grid container spacing={2}>
          <Grid item xs={12} sm={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <img
              src={Micro}
              alt="Descripción de la imagen"
              style={{ maxWidth: '500px', height: '300px', marginTop: '20px' }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body1" align="left">
              <p style={{fontSize: '15px'}}>El servicio de Asistencia Tecnológica permite resolver, en tiempo real, las consultas o incidencias relacionadas con el uso habitual de equipos informáticos, smartphones y tablets, de forma remota y sin necesidad de que el usuario tenga que desplazarse de su domicilio y/u oficina.</p>
              <p style={{fontSize: '15px'}}>La asistencia se prestará a través de una ventana de diálogo tipo chat, que permitirá al usuario contactar con nuestros técnicos expertos. Adicionalmente, en caso de que el usuario no pueda conectar su equipo a Internet, podrá solicitar asistencia por teléfono.</p>
              <p style={{fontSize: '15px'}}>Cada usuario podrá utilizar este servicio siempre que lo necesite, las 24 horas del día, los 365 días del año, sin que existan restricciones de uso ni en el número de consultas ni en el tiempo de utilización. La atención que se presta al usuario es inmediata, totalmente personalizada, siempre bajo su conformidad y de manera que le ocasione las menores molestias posibles.</p>
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Typography variant="body1" align="left">
              <h4>Como acceder</h4>
              <ol style={{paddingInlineStart: '20px'}}>
                <li>Para comenzar a utilizar este servicio, en primer lugar debe registrarse; el registro sólo debe realizarse la primera vez que acceda a alguno de los servicios contenidos en la solución.</li>
                <li>Una vez que se haya registrado, podrá acceder a todos los servicios. Seleccione en Acceda al servicio y comience a disfrutar del mismo.</li>
              </ol>
              <Box
                  component={Link}
                  to="/"
                  sx={{
                    display: 'inline-flex', // Asegura que los íconos y el texto se alineen correctamente
                    alignItems: 'center', // Centra el contenido del enlace verticalmente
                    bgcolor: 'red',
                    '&:hover': {
                      bgcolor: 'darkred',
                    },
                    color: 'white', // Establece el color del texto e ícono a blanco
                    textDecoration: 'none', // Remueve el subrayado del enlace
                    width: '50%', // O ajusta según sea necesario
                    justifyContent: 'center', // Centra el contenido horizontalmente si es necesario
                    padding: '6px 16px', // Ajusta el padding para igualar al del Button, si es necesario
                  }}
                >
                  Accede al sitio
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Typography variant="body1" align="left">
              <h4>Cómo usar</h4>
              <ol style={{paddingInlineStart: '20px'}}>
                <li>Una vez que haya accedido al servicio, podrá iniciar una conversación vía chat con nuestros técnicos en la sección “Consulta a un experto". A continuación seleccione “conectar” e iniciará una conversación con un técnico.</li>
                <li>Si por el contrario desea contactar con un técnico en relación a una consulta abierta, podrá reanudar la conversación en la sección “Historial”.</li>
              </ol>
            </Typography>
          </Grid>
        </Grid>
        </>
  );
}